import { Lock } from 'lucide-react'
import { Alert } from './ui/alert.tsx'
import { useAdminMode } from '../lib/useAdminMode.tsx'

/**
 * Lišta na obrazovkách, které jsou při zamčené správě jen ke čtení.
 * Nenabízí tlačítko — odemyká se z příkazové řádky, ne z prohlížeče, a nabídka,
 * která nikam nevede, je horší než žádná.
 */
export function AdminNotice({ what }: { what: string }) {
  const { locked } = useAdminMode()
  if (!locked) return null
  return (
    <Alert className="mb-4">
      <Lock size={16} aria-hidden className="shrink-0 text-[var(--muted-foreground)]" />
      <p className="flex-1">
        {what} je teď jen ke čtení. Správa se odemyká na serveru příkazem{' '}
        <code className="rounded-[var(--radius-sm)] bg-[var(--secondary)] px-1 py-0.5 font-mono text-[length:var(--text-xs)]">make admin-on</code>.
      </p>
    </Alert>
  )
}
